import WebFont from "webfontloader";

WebFont.load({
  google: {
    families: ["Roboto:300,400,500,700"],
  },
});
